// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jh-0";
export var assigneeDetails = "_jh-1";
export var assigneeInfo = "_jh-2";
export var dropdownContainer = "_jh-4";
export var dropdownImage = "_jh-5";
export var editAssigneeInfo = "_jh-3";
export var editAssigneeModalContainer = "_jh-6";
export var hidden = "_jh-8";
export var input = "_jh-7";